import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '电影', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '动漫', path: '/category/anime' },
    { label: '综艺', path: '/category/variety' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '动作电影', path: '/category/movie' },
    { label: '喜剧电影', path: '/category/movie' },
    { label: '科幻电影', path: '/category/movie' },
    { label: '国产剧', path: '/category/tv' },
    { label: '海外剧', path: '/category/tv' },
    { label: '日本动漫', path: '/category/anime' },
  ],
  support: [
    { label: '常见问题', path: '/about' },
    { label: '联系我们', path: '/about' },
    { label: '关于我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                屁屁影院
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              屁屁影院是您的首选在线观影平台，提供海量高清电影、电视剧、动漫免费在线播放。汇聚全球热门影视资源，画质清晰、更新及时。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              影视分类
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              帮助支持
            </h4>
            <ul className="space-y-2.5 mb-6">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="space-y-2 text-sm text-foreground-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>service@pipicinema.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6666</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} 屁屁影院 版权所有 | 高清影视在线观看平台
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}